import {
  ORDER_HISTORY_REQUEST,
  ORDER_HISTORY_SUCCESS,
  ORDER_HISTORY_FAILURE,
  LOAD_MORE_ORDER_HISTORY,
  HIDE_LOAD_MORE_ORDER_HISTORY,
} from '../../actions/types';

import { ORDERS_PER_ORDER_HISTORY_PAGE } from '../../actions/orderActions';

import { createOrderHistory } from './factories';

const initialState = {
  error: null,
  loading: false,
  orders: [],
  orderHistoryPage: 0,
  showLoadMoreButton: true,
};

export default function historyReducer(state = initialState, action = {}) {
  switch (action.type) {
    case ORDER_HISTORY_REQUEST:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case ORDER_HISTORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: {
          statusCode: action.status,
          message: action.message,
        },
      };
    case ORDER_HISTORY_SUCCESS: {
      /* TODO: Remove once we get proper pagination from API */
      const ordersPerPage = action.payload.orders.slice(0, ORDERS_PER_ORDER_HISTORY_PAGE);

      return {
        ...state,
        orders: [...state.orders, ...createOrderHistory(ordersPerPage)],
        loading: false,
      };
    }
    case LOAD_MORE_ORDER_HISTORY:
      return {
        ...state,
        orderHistoryPage: state.orderHistoryPage + 1,
      };
    case HIDE_LOAD_MORE_ORDER_HISTORY:
      return {
        ...state,
        showLoadMoreButton: false,
      };
    default:
      return { ...state };
  }
}
